import PropTypes from 'prop-types';
import { Tooltip } from '@mantine/core';
import { NavLink } from 'react-router-dom';
import clsx from 'clsx';
import classes from './navbarLink.module.css';

const NavbarLink = (props) => {
  const {
    label,
    tooltip,
    icon: Icon,
    to,
    onClick,
    last,
    disableTooltip = false,
  } = props;

  const navLinkClasses = ({ isActive }) => clsx(
    classes.mainlink,
    isActive && classes.active,
    last && classes.last,
  );

  const navButtonClasses = clsx(
    classes.mainlink,
    last && classes.last,
  );

  const handleButtonClick = (e) => {
    e.preventDefault();
    onClick();
  };

  const body = (onClick)
    ? (
      <button
        className={navButtonClasses}
        onClick={handleButtonClick}
      >
        <div className={classes.icon}><Icon stroke={1.5} /></div>
        <div className={classes.label}>{label}</div>
      </button>
    )
    : (
      <NavLink to={to} className={navLinkClasses}>
        <div className={classes.icon}><Icon stroke={1.5} /></div>
        <div className={classes.label}>{label}</div>
      </NavLink>
    );

  return (
    <Tooltip
      label={tooltip || label}
      position="left"
      disabled={disableTooltip}
    >
      {body}
    </Tooltip>
  );
};

NavbarLink.propTypes = {
  icon: PropTypes.any,
  label: PropTypes.string,
  tooltip: PropTypes.string,
  to: PropTypes.string,
  onClick: PropTypes.func,
  last: PropTypes.bool,
  disableTooltip: PropTypes.bool,
};

export default NavbarLink;
